import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-117dffb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chip-group-block-head" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "mt-1 chip-group-wrapper" }
const _hoisted_4 = { class: "contact-list-head" }
const _hoisted_5 = { class: "label" }

import SearchInput from '@/components/ui/SearchInput.vue';
import AppBottomBar from '@/components/AppBottomBar.vue';
import { useClientStore } from '@/store/client';
import { useTagStore } from '@/store/tag';
import { Client, ClientQrResponse } from '@/types';
import ClientStatus from '@/types/ClientStatus';
import Tag from '@/types/interfaces/Tag';
import { DATE_FORMAT, IMAGE_BASE64_PREFIX } from '@/utils/constants';
import { REFRESH_QR, SEND_ACCESS_CLIENT_QR, SUBMIT_FORM } from '@/utils/events';
import { authUserHasPermission, getClientStatusText } from '@/utils/functions';
import useVuelidate from '@vuelidate/core';
import { email, helpers, required } from '@vuelidate/validators';
import moment from 'moment';
import { onBeforeMount, reactive, ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import find from 'lodash/find';
import orderBy from 'lodash/orderBy';
import PreviewContactlistStatus from '@/types/PreviewContactlistStatus';

const ORDER_TAGS_FIELD = 'name';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientForm',
  props: {
  inProcess: {
    type: Boolean,
    default: false
  },
  qrInProcess: {
    type: Boolean,
    default: false
  },
  sendAccessInProcess: {
    type: Boolean,
    default: false
  },
  formData: {
    type: Object
  },
  edit: {
    type: Boolean,
    default: false
  }
},
  emits: [SUBMIT_FORM, REFRESH_QR, SEND_ACCESS_CLIENT_QR],
  setup(__props, { emit: __emit }) {

const allTags = ref([] as Tag[]);
const visibleTags = ref([] as Tag[]);
const existedClientContactList = ref([] as Client[]);
const contactList = ref([] as Client[]);
const previewContactList = ref([] as Client[]);
const needShowTags = authUserHasPermission('tags');

onBeforeMount(async () => {

  if(needShowTags){
    await tagStore.fetchTags().then(
      (listTags: Tag[]) => {
        const orderedListTags = orderBy(listTags, ORDER_TAGS_FIELD);
        allTags.value = orderedListTags;
        visibleTags.value = orderedListTags;
      },
      () => {}
    );

    if (props.edit) {
      loadClientContactList();
    }
  }
});

const emit = __emit;
const { t } = useI18n();
const tagStore = useTagStore();
const clientStore = useClientStore();
const props = __props;
const search = ref('');
const searchContactList = ref('');
const localData = reactive({
  existedClient: {} as Client,
  modeEdit: props.edit
});
const qrDialog = ref({
  show: false,
  imageString: '',
  code: '',
  inProcess: false
});

const preFormData = localData.modeEdit
  ? {
    firstName: props.formData?.firstName,
    lastName: props.formData?.lastName,
    email: props.formData?.email,
    phone: props.formData?.phone,
    status: props.formData?.status,
    teleguardId: props.formData?.teleguardId,
    createdAt: props.formData?.createdAt,
    createdAtFormatted: moment(props.formData?.createdAt).format(DATE_FORMAT),
    tags: props.formData?.tags?.map((tag: Tag) => tag.id!)
  }
  : {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    teleguardId: '',
    useCustmomTeleguardId: false
  };

const formDataLocal = reactive(preFormData);
const needShowQR = [
  ClientStatus.VERIFIED,
  ClientStatus.REVERIFIED,
  ClientStatus.CREATED,
  ClientStatus.RECREATED
].includes(formDataLocal.status);
const needShowRefreshQR = [
  ClientStatus.VERIFIED,
  ClientStatus.REVERIFIED,
  ClientStatus.ACTIVE,
  ClientStatus.DISABLED
].includes(formDataLocal.status);

const gridVariantExtended = computed(() => {
  return needShowQR && needShowRefreshQR;
});

const rules = {
  firstName: {
    required: helpers.withMessage(t('TextFieldError.Required', { field: t('TextField.FirstName') }), required)
  },
  lastName: {
    required: helpers.withMessage(t('TextFieldError.Required', { field: t('TextField.LastName') }), required)
  },
  email: {
    required: helpers.withMessage(t('TextFieldError.Required', { field: t('TextField.Email') }), required),
    email: helpers.withMessage(t('TextFieldError.Email', { field: t('TextField.Email') }), email)
  },
  phone: {
    onlyCustomSymbols: helpers.withMessage(
      t('TextFieldError.OnlyClearPhoneNumber', { field: t('TextField.Phone') }),
      (): boolean => {
        return formDataLocal.phone.length > 0 ? /^\+?[0-9()\s]*$/.test(formDataLocal.phone) : true;
      }
    )
  },
  teleguardId: {
    required: helpers.withMessage(t('TextFieldError.Required', { field: t('TextField.TeleguardId') }), (): boolean => {
      return formDataLocal.useCustmomTeleguardId ? formDataLocal.teleguardId.trim().length > 0 : true;
    }),
    correctTeleguardIdSymbols: helpers.withMessage(
      t('TextFieldError.CustomTeleguardId', { field: t('TextField.TeleguardId') }),
      (): boolean => {
        return formDataLocal.useCustmomTeleguardId ? /^[a-zA-Z0-9.\-_]*$/.test(formDataLocal.teleguardId) : true;
      }
    )
  }
};
const v$ = useVuelidate(rules, formDataLocal);

function generateFieldErrors(_fieldName: string) {
  return v$.value[_fieldName].$errors.map((errorItem: any) => errorItem.$message);
}

async function onClick() {
  if (await v$.value.$validate()) {
    emit(SUBMIT_FORM, { formData: formDataLocal, localData });
  } else {
    return false;
  }
}

function onChangeSearch() {
  if (search.value.length > 0) {
    visibleTags.value = orderBy(
      allTags.value.filter((tag: Tag) => {
        if (tag.name.toLocaleLowerCase().includes(search.value.toLocaleLowerCase())) {
          return tag;
        }
      }),
      ORDER_TAGS_FIELD
    );
  } else visibleTags.value = allTags.value;
}

function clearSearch() {
  search.value = '';
  visibleTags.value = allTags.value;
}

function showQrCode() {
  qrDialog.value.inProcess = true;
  clientStore
    .getClientQR(props.formData?.id)
    .then((clientQrResponse: ClientQrResponse) => {
      qrDialog.value.imageString = `${IMAGE_BASE64_PREFIX}, ${clientQrResponse.qrImage}`;
      qrDialog.value.code = clientQrResponse.code;
    })
    .finally(() => (qrDialog.value.inProcess = false));

  qrDialog.value.show = true;
}

function refreshClientQR() {
  emit(REFRESH_QR);
}

function sendAccessClientQR() {
  emit(SEND_ACCESS_CLIENT_QR);
}

function onUpdateUseCustomTeleguardId() {
  formDataLocal.teleguardId = '';
}

function loadClientContactList() {
  clientStore.getClientContactList(Number(props.formData?.id)).then((_contactList: Client[]) => {
    existedClientContactList.value = orderBy(_contactList, 'firstName', 'asc');
    contactList.value = existedClientContactList.value;
    previewContactList.value = existedClientContactList.value;
  });
}

function onChangeSearchContactList() {
  if (searchContactList.value.length > 0) {
    contactList.value = previewContactList.value.filter((friend: Client) => {
      if (
        friend.email!.toLocaleLowerCase().includes(searchContactList.value.toLocaleLowerCase()) ||
        friend.teleguardId!.toLocaleLowerCase().includes(searchContactList.value.toLocaleLowerCase()) ||
        friend.firstName!.toLocaleLowerCase().includes(searchContactList.value.toLocaleLowerCase()) ||
        friend.lastName!.toLocaleLowerCase().includes(searchContactList.value.toLocaleLowerCase())
      ) {
        return friend;
      }
    });
  } else {
    contactList.value = previewContactList.value;
  }
}
function clearSearchContactList() {
  searchContactList.value = '';
  contactList.value = previewContactList.value;
}

async function tagListOnChange() {
  let onlyNewFriends: Client[] = [];
  let currentFriends: Client[] = [];
  let removedFriends: Client[] = [];
  if (formDataLocal.tags.length > 0) {
    const clientId = localData.modeEdit ? Number(props.formData?.id) : null;
    await clientStore.getPreviewContactList(clientId, formDataLocal.tags).then((_previewContactList: Client[]) => {
      onlyNewFriends = _previewContactList.filter((newFriend) => {
        if (find(existedClientContactList.value, { id: newFriend.id }) === undefined) {
          newFriend.previewStatus = PreviewContactlistStatus.ADDED;
          return newFriend;
        }
      });
      existedClientContactList.value.map((currentFriend) => {
        const isExistingFriend = find(_previewContactList, { id: currentFriend.id }) !== undefined;
        if (isExistingFriend) {
          currentFriend.previewStatus = PreviewContactlistStatus.CURRENT;
          currentFriends.push(currentFriend);
        } else {
          currentFriend.previewStatus = PreviewContactlistStatus.REMOVED;
          removedFriends.push(currentFriend);
        }
      });
    });
  } else {
    contactList.value = localData.modeEdit
      ? existedClientContactList.value.map((friend) => {
        friend.previewStatus = PreviewContactlistStatus.REMOVED;
        removedFriends.push(friend);
        return friend;
      })
      : [];
  }
  onlyNewFriends = orderBy(onlyNewFriends, 'firstName', 'asc');
  currentFriends = orderBy(currentFriends, 'firstName', 'asc');
  removedFriends = orderBy(removedFriends, 'firstName', 'asc');
  contactList.value = [...removedFriends, ...onlyNewFriends, ...currentFriends];
  previewContactList.value = contactList.value;
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_dialog, {
        modelValue: qrDialog.value.show,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((qrDialog.value.show) = $event)),
        persistent: "",
        width: "340"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "d-flex justify-center mt-2" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(formDataLocal.teleguardId), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "d-flex" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    width: "250",
                    height: "250",
                    class: "mx-0 px-0",
                    src: qrDialog.value.imageString
                  }, null, 8, ["src"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "d-flex justify-center font-weight-medium text-h6" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(qrDialog.value.code), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "text",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (qrDialog.value.show = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Button.Ok')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_form, { class: "mt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "px-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: formDataLocal.firstName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formDataLocal.firstName) = $event)),
                    modelModifiers: { trim: true },
                    variant: "outlined",
                    color: "primary",
                    "bg-color": "input-background",
                    label: _ctx.$t('TextField.FirstName'),
                    "error-messages": generateFieldErrors('firstName'),
                    required: "",
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "label", "error-messages"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: formDataLocal.lastName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formDataLocal.lastName) = $event)),
                    modelModifiers: { trim: true },
                    variant: "outlined",
                    color: "primary",
                    "bg-color": "input-background",
                    label: _ctx.$t('TextField.LastName'),
                    "error-messages": generateFieldErrors('lastName'),
                    required: "",
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "label", "error-messages"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "px-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: formDataLocal.email,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formDataLocal.email) = $event)),
                    modelModifiers: { trim: true },
                    variant: "outlined",
                    color: "primary",
                    "bg-color": "input-background",
                    label: _ctx.$t('TextField.Email'),
                    "error-messages": generateFieldErrors('email'),
                    required: "",
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "label", "error-messages"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: formDataLocal.phone,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formDataLocal.phone) = $event)),
                    modelModifiers: { trim: true },
                    variant: "outlined",
                    color: "primary",
                    "bg-color": "input-background",
                    label: _ctx.$t('TextField.Phone'),
                    "error-messages": generateFieldErrors('phone'),
                    required: "",
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "label", "error-messages"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (localData.modeEdit)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                class: "px-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: formDataLocal.teleguardId,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formDataLocal.teleguardId) = $event)),
                        modelModifiers: { trim: true },
                        variant: "outlined",
                        color: "primary",
                        "bg-color": "input-background",
                        label: _ctx.$t('TextField.TeleguardId'),
                        readonly: ""
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: formDataLocal.createdAtFormatted,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formDataLocal.createdAtFormatted) = $event)),
                        modelModifiers: { trim: true },
                        variant: "outlined",
                        color: "primary",
                        "bg-color": "input-background",
                        label: _ctx.$t('TextField.CreatedAt'),
                        readonly: ""
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!localData.modeEdit)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                class: "pa-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: formDataLocal.teleguardId,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formDataLocal.teleguardId) = $event)),
                        modelModifiers: { trim: true },
                        variant: "outlined",
                        color: "primary",
                        "bg-color": "input-background",
                        label: _ctx.$t('TextField.TeleguardId'),
                        disabled: !formDataLocal.useCustmomTeleguardId,
                        "error-messages": generateFieldErrors('teleguardId')
                      }, null, 8, ["modelValue", "label", "disabled", "error-messages"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_checkbox, {
                        modelValue: formDataLocal.useCustmomTeleguardId,
                        "onUpdate:modelValue": [
                          _cache[9] || (_cache[9] = ($event: any) => ((formDataLocal.useCustmomTeleguardId) = $event)),
                          onUpdateUseCustomTeleguardId
                        ],
                        label: _ctx.$t('Label.Client.UseCustomTeleguardId'),
                        color: "primary"
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (localData.modeEdit)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 2,
                class: "px-4"
              }, {
                default: _withCtx(() => [
                  (_unref(needShowQR))
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "12",
                        sm: "12",
                        md: gridVariantExtended.value ? 4 : 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { class: "ma-0 pa-0 d-flex" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "7",
                                class: "ma-0 px-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    class: "qr-code-button",
                                    variant: "outlined",
                                    color: "primary",
                                    "prepend-icon": "mdi-qrcode-scan",
                                    onClick: showQrCode
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('Label.QRCode')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "5",
                                class: "ma-0 px-0 d-flex justify-end"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    class: "qr-code-button",
                                    variant: "outlined",
                                    color: "primary",
                                    "prepend-icon": "mdi-email-arrow-right-outline",
                                    loading: __props.sendAccessInProcess,
                                    disabled: __props.sendAccessInProcess,
                                    onClick: sendAccessClientQR
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('Label.SendQRCode')), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["loading", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["md"]))
                    : _createCommentVNode("", true),
                  (_unref(needShowRefreshQR))
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 1,
                        cols: "12",
                        sm: "12",
                        md: gridVariantExtended.value ? 4 : 6,
                        class: _normalizeClass({ 'd-flex justify-center align-center': gridVariantExtended.value })
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            class: "qr-code-button",
                            variant: "outlined",
                            color: "primary",
                            "prepend-icon": "mdi-qrcode-scan",
                            loading: __props.qrInProcess,
                            onClick: refreshClientQR
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('Label.GenerateNewQrCode')), 1)
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      }, 8, ["md", "class"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: gridVariantExtended.value ? 4 : 6,
                    class: "d-flex"
                  }, {
                    default: _withCtx(() => [
                      (!(formDataLocal.status == _unref(ClientStatus).ACTIVE || formDataLocal.status == _unref(ClientStatus).DISABLED))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["align-self-center", { 'd-flex align-self-center justify-end w-100': gridVariantExtended.value }])
                          }, _toDisplayString(`${_ctx.$t('TextField.Status')}: ${_ctx.$t(_unref(getClientStatusText)(formDataLocal.status))}`), 3))
                        : _createCommentVNode("", true),
                      (formDataLocal.status == _unref(ClientStatus).ACTIVE || formDataLocal.status == _unref(ClientStatus).DISABLED)
                        ? (_openBlock(), _createBlock(_component_v_switch, {
                            key: 1,
                            modelValue: formDataLocal.status,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formDataLocal.status) = $event)),
                            "true-value": _unref(ClientStatus).ACTIVE,
                            "false-value": _unref(ClientStatus).DISABLED,
                            color: "primary",
                            "hide-details": "",
                            label: `${_ctx.$t('TextField.Status')}: ${_ctx.$t(_unref(getClientStatusText)(formDataLocal.status))}`
                          }, null, 8, ["modelValue", "true-value", "false-value", "label"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["md"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(needShowTags))
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 3,
                class: "row-divider px-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    class: "pt-4",
                    cols: "12",
                    sm: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('Label.Client.Tags')), 1),
                        _createVNode(_component_v_spacer),
                        _createVNode(SearchInput, {
                          modelValue: search.value,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((search).value = $event)),
                          "onClick:clear": clearSearch,
                          onInput: onChangeSearch
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_v_chip_group, {
                          modelValue: formDataLocal.tags,
                          "onUpdate:modelValue": [
                            _cache[12] || (_cache[12] = ($event: any) => ((formDataLocal.tags) = $event)),
                            tagListOnChange
                          ],
                          column: "",
                          multiple: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleTags.value, (tag) => {
                              return (_openBlock(), _createBlock(_component_v_chip, {
                                key: tag.id,
                                filter: "",
                                color: "primary",
                                variant: "outlined",
                                "selected-class": "no-border",
                                value: tag.id,
                                rounded: true
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(tag.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    class: "col-divider pt-4",
                    cols: "12",
                    sm: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('Label.Client.Contacts')), 1),
                        _createVNode(_component_v_spacer),
                        _createVNode(SearchInput, {
                          modelValue: searchContactList.value,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((searchContactList).value = $event)),
                          class: "align-self-end",
                          "onClick:clear": clearSearchContactList,
                          onInput: onChangeSearchContactList
                        }, null, 8, ["modelValue"])
                      ]),
                      _createVNode(_component_v_list, { class: "pt-0 mt-1 contact-list" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactList.value, (friend) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: friend.teleguardId,
                              title: friend.firstName + ' ' + friend.lastName,
                              subtitle: friend.teleguardId,
                              class: _normalizeClass({
                           'preview-added': friend.previewStatus == _unref(PreviewContactlistStatus).ADDED,
                           'preview-removed': friend.previewStatus == _unref(PreviewContactlistStatus).REMOVED,
                           preview: friend.previewStatus == _unref(PreviewContactlistStatus).CURRENT
                         })
                            }, {
                              append: _withCtx(() => [
                                (friend.previewStatus == _unref(PreviewContactlistStatus).ADDED)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      icon: "mdi-account-plus-outline",
                                      color: "primary"
                                    }))
                                  : _createCommentVNode("", true),
                                (friend.previewStatus == _unref(PreviewContactlistStatus).REMOVED)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 1,
                                      icon: "mdi-account-minus-outline",
                                      color: "error"
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["title", "subtitle", "class"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(AppBottomBar, { class: "justify-end" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "flat",
            disabled: __props.inProcess,
            loading: __props.inProcess,
            onClick: onClick
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(localData.modeEdit ? _ctx.$t('Button.Save') : _ctx.$t('Button.Create')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})